import {
  CreateScheduledHolidayMetadataInput,
  CreateScheduledHolidayMetadataMutation,
  CreateScheduledHolidayMetadataMutationVariables,
  UpdateScheduledHolidayMetadataInput,
  UpdateScheduledHolidayMetadataMutation,
  UpdateScheduledHolidayMetadataMutationVariables,
} from '@/API';
import { graphqlQuery } from '@/appsync/service/GraphqlUtils';
import {
  createScheduledHolidayMetadata as createHolidayMutation,
  updateScheduledHolidayMetadata as updateHolidayMutation,
} from '@/graphql/mutations';

export const createScheduledHolidayMetadata = async (
  holiday: CreateScheduledHolidayMetadataInput
): Promise<void> => {
  const variables: CreateScheduledHolidayMetadataMutationVariables = {
    input: holiday,
  };

  await graphqlQuery<
    CreateScheduledHolidayMetadataMutation,
    CreateScheduledHolidayMetadataMutationVariables
  >(createHolidayMutation, variables);
};

export const updateScheduledHolidayMetadata = async (
  holiday: UpdateScheduledHolidayMetadataInput
): Promise<void> => {
  const variables: UpdateScheduledHolidayMetadataMutationVariables = {
    input: holiday,
  };

  await graphqlQuery<
    UpdateScheduledHolidayMetadataMutation,
    UpdateScheduledHolidayMetadataMutationVariables
  >(updateHolidayMutation, variables);
};
